export default __webpack_public_path__ + "static/media/spratt6.245264aa.jpg";